import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TranslateMessage from "./translateMessage";
import { connect } from "react-redux";
import { messageAi } from "actions/aiActions";

const MessageContent = ({ data, showTrans = true, messageAi, setLoading, setImage }) => {
    const [messageTrans, setMessageTrans] = useState({});
    const { t } = useTranslation();
    try {
        let product = data?.product;
        const mess = JSON.parse(data?.content);
        const handleTranslate = async (id, text) => {
            setLoading(true);
            const data = await messageAi(text);
            if (data) setMessageTrans((prev) => ({ ...prev, [id]: data }));
            setLoading(false);
        };

        if (data.type === "IMAGE" && mess?.url)
            return (
                <img
                    className="al-cursor-pointer"
                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                    alt="message"
                    src={mess?.url}
                    onClick={() => setImage(mess?.url)}
                />
            );

        if (mess.order_id) {
            if (mess.order)
                return (
                    <span className="btn btn-light btn-sm">
                        <p>Order Id: 123123</p>
                        <p>Items: {mess.order?.line_items?.length}</p>
                        <span>Payment: {`${mess?.order?.payment.total_amount} ${mess?.order?.payment.currency}`}</span>
                    </span>
                );

            return (
                <span className="btn btn-light btn-sm">
                    Order id {data.type === "RETURN_REFUND_CARD" && "Refund"}: ({mess.order_id})
                </span>
            );
        }

        if (mess.product_id) {
            if (product) {
                return (
                    <div className="bg-white p-2 rounded border mb-2 p-2 text-start">
                        <div className="d-flex align-items-center gap-4">
                            <div style={{ minWidth: 60, height: 60, backgroundColor: "#ddd" }}>
                                <img
                                    src={product.main_images?.[0]}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            </div>
                            <div>
                                <span title={product.title} className="ellipsis">
                                    {product.title}
                                </span>
                                <div>
                                    <span role="button" className="text-decoration-none text-primary small">
                                        {`${product.price} $`}
                                    </span>
                                    <div className="mt-4 d-flex gap-4">
                                        <Link
                                            to={"https://shop.tiktok.com/view/product/" + product.apiProductId}
                                            className="btn btn-light btn-sm"
                                            target="_blank"
                                        >
                                            View Detail
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }

            return (
                <Link
                    to={"https://shop.tiktok.com/view/product/" + mess.product_id}
                    className="btn btn-light btn-sm"
                    target="_blank"
                >
                    View Detail Product ({mess.product_id})
                </Link>
            );
        }

        if (mess?.coupon_id) {
            if (data?.coupontiktok) {

                const { discount, threshold, redemption_duration, product_scope, display_type, title, id, auto_coupon } = data?.coupontiktok;

                let discountText = "";
                if (discount.type === "AMOUNT_OFF") {
                    discountText = `${discount.reduction_amount.currency}${discount.reduction_amount.amount} off`;
                } else if (discount.type === "PERCENT_OFF") {
                    discountText = `${discount.percentage}% off`;
                    if (discount.max_discount?.amount) {
                        discountText += ` (Max: ${discount.max_discount.currency}${discount.max_discount.amount})`;
                    }
                }

                // Điều kiện mua tối thiểu
                const showMinSpend = threshold?.type === "MIN_SPEND";
                const minSpendText = showMinSpend
                    ? `on order over ${threshold.min_spend.currency}${threshold.min_spend.amount}`
                    : "No minimum spend";

                // Phạm vi sản phẩm
                const productScopeText =
                    product_scope === "FULL_SHOP" ? "All products" : "Only specified products";

                // Thời gian hiệu lực
                const validityDays = redemption_duration?.relative_time;

                return (
                    <div className="card shadow-sm mb-3 p-3 rounded-4">
                        <h4>Coupons</h4>
                        <div className="card-body p-3 d-flex align-items-start flex-column  rounded-4" style={{
                            border: "1px dashed #131313ff",
                            margin: "1rem 0",
                            backgroundColor: "#fff3f3ff"
                        }}>
                            <div className="d-flex align-items-start mb-2">
                                <span className="badge bg-danger me-2 text-light">{display_type}</span>
                            </div>

                            <h2 className="fw-bold">{discountText}</h2>

                            {showMinSpend && (
                                <p className="mb-1">
                                    <strong>{minSpendText}</strong>
                                </p>
                            )}

                            {/* <p className="mb-1">
                                <strong>{productScopeText}</strong>
                            </p> */}

                            {validityDays && (
                                <p className="mb-3">
                                    {validityDays} days after claiming
                                </p>
                            )}

                            {/* <div className="d-flex">
                                <span className="btn btn-sm btn-info me-5" onClick={() => onClickSendMessage(id, "COUPON_CARD")}>Send</span>
                                <div className="form-check form-switch d-flex justify-content-center align-items-center" onClick={() => handleSetAutoCounpon(id, !auto_coupon)}>
                                    <input className="form-check-input me-3" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked={auto_coupon === true ? true : false} />
                                    <label className="form-check-label" for="flexSwitchCheckChecked">Auto Coupon</label>
                                </div>
                            </div> */}
                        </div>
                    </div>
                );
            }

            return (
                <Link
                    to="#"
                    className="btn btn-light btn-sm"
                    target="_blank"
                >
                    Counpon ID sent: ({mess?.coupon_id})
                </Link>
            );
        }

        if (data.type === "VIDEO" && mess?.url) {
            return (
                <video width="300" controls>
                    <source src={mess?.url} type="video/mp4" />
                </video>
            );
        }

        return (
            <div>
                {mess.content}
                {showTrans && (
                    <>
                        <span
                            role="button"
                            onClick={(e) => handleTranslate(data.messages_tiktok_id, mess.content)}
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={t("Translate")}
                        >
                            <i className="ki-duotone ki-messages ms-2 fs-2" aria-hidden="true">
                                <span className="path1"></span>
                                <span className="path2"></span>
                                <span className="path3"></span>
                                <span className="path4"></span>
                                <span className="path5"></span>
                            </i>
                        </span>
                        <TranslateMessage data={messageTrans?.[data.messages_tiktok_id]} />
                    </>
                )}
            </div>
        );
    } catch {
        return "";
    }
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    messageAi,
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageContent);
